import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=2bb2d622&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports